import { OrderedMap } from "immutable";

import {
  GET_SPECIAL_FEATURES_REQUESTED,
  GET_SPECIAL_FEATURES_SUCCEEDED,
  GET_SPECIAL_FEATURES_FAILED,
} from "settings/actions/specialFeatures";

const initialState = {
  specialFeatures: OrderedMap(),
  isLoading: false,
  error: false,
};

const arrayOfSpecialFeaturesToOrderedMap = results =>
  OrderedMap(results.map(result => [result.id, result]));

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SPECIAL_FEATURES_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };

    case GET_SPECIAL_FEATURES_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        specialFeatures: arrayOfSpecialFeaturesToOrderedMap(
          action.payload.results
        ),
      };

    case GET_SPECIAL_FEATURES_FAILED:
      return {
        ...state,
        isLoading: false,
        error: true,
      };

    default:
      return state;
  }
};
